(function (window, document, $) {
    'use strict';

    var getBreakpoint = function () {
        return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
    };

    $(function () {

        $('div.navbar-collapse').on('shown.bs.collapse', function () {
            const breakpoint = getBreakpoint();
            if (breakpoint === 'xs' || breakpoint === 'ms' || breakpoint === 'md') {
                if ($('div.navbar-collapse').find('div.dropdown-menu').is(':hidden')) {
                    $('div.navbar-collapse').find('a.dropdown-toggle').first().dropdown('toggle');
                }
            }
        });
    });
}(window, document, jQuery));